import { useLayoutEffect, useRef, useState } from 'react';

export const useElementDimensions = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  const [height, setHeight] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries?.[0]?.contentRect) {
        const { height: elementHeight, width: elementWidth } = entries[0].contentRect;
        setHeight(elementHeight);
        setWidth(elementWidth);
      }
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      setHeight(0);
      setWidth(0);
      resizeObserver.disconnect();
    };
  }, [ref]);

  return {
    ref,
    height,
    width,
  };
};
